import React, { useCallback, useEffect, useRef } from "react";
import classNames from "classnames";
import { Checkbox } from "@blueprintjs/core";
import * as styles from "./styles.module.scss";
const CheckBoxInput = ({ value, onChange, indeterminate, className, disabled, autoFocus, grey, white, }) => {
    const inputRef = useRef(null);
    const handleChange = useCallback((event) => {
        if (onChange) {
            onChange(event.target.checked);
        }
    }, [onChange]);
    useEffect(() => {
        if (!autoFocus) {
            return;
        }
        if (inputRef.current) {
            setTimeout(() => inputRef?.current?.focus(), 0);
        }
    }, [autoFocus]);
    return (React.createElement(Checkbox, { type: "checkbox", className: classNames(styles.checkbox, className, {
            [styles.checkboxGray]: grey,
            [styles.checkboxWhite]: white,
            [styles.disabled]: disabled,
        }), checked: value ?? undefined, onChange: handleChange, indeterminate: indeterminate, disabled: disabled, inputRef: inputRef, inline: true }));
};
export default CheckBoxInput;
